const initialState = {
  deviceHistoryList: [
    {
      'Task_UID': '',
      'CreatedAt': '',
      'Store_Number': '',
      'LaneConfig_Name': '',
      'Device_MainVersion': '',
      'CreatedBy': ''
    }
  ]
}

export default function deviceHistoryDetails (state = initialState, action) {
  switch (action.type) {
    case 'GET_DEVICE_HISTORY_LIST':
      state.deviceHistoryList = action.deviceHistoryList
      return {
        ...state
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/store/devicehistorylist.js